import { render, staticRenderFns } from "./LookupFactoryMaterialComponent.vue?vue&type=template&id=b28dc9a6&scoped=true&"
import script from "./LookupFactoryMaterialComponent.vue?vue&type=script&lang=js&"
export * from "./LookupFactoryMaterialComponent.vue?vue&type=script&lang=js&"
import style0 from "./LookupFactoryMaterialComponent.vue?vue&type=style&index=0&id=b28dc9a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28dc9a6",
  null
  
)

export default component.exports